import React from 'react';
import { path, sortWith, descend, compose } from 'ramda';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';
import CommonViewButton from 'routes/Documents/components/CommonViewButton';

import { formatHeaderDate, editTimeLeft, dateValue } from 'lib/dateDisplay';
import { getLatestCommitData } from 'lib/documentHandling';

//import calculate from '../calculateFSS';

export const sorter = sortWith([descend(compose(dateValue, path(['createDate'])))]);

const msg = id => ({ id });

const renderEntryHeader = (doc, fm) => `${formatHeaderDate(doc.createDate)}`;

const renderHeader = m => <p children={m} />;

const historyMapper =
  (name, edit, view) =>
  (d, { formatMessage }) => (
    <HistoryEntry key={d.documentId}>
      <HistoryEntryHeader title={renderEntryHeader(d, formatMessage)} active={null}>
        {/* <CommonViewButton onView={e => view('sdmt', d.documentId)} /> */}
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('sdmt.labels.testMode')))}>
          <p>
            {getLatestCommitData(d).sdmtResult && getLatestCommitData(d).sdmtResult.testMode === 'oral'
              ? formatMessage(msg('sdmt.labels.testModeOral'))
              : formatMessage(msg('sdmt.labels.testModeSelf'))}
          </p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('sdmt.labels.filled')))}>
          <p>
            {((getLatestCommitData(d).sdmtResult &&
              getLatestCommitData(d).sdmtResult.testAnswers &&
              getLatestCommitData(d).sdmtResult.testAnswers.length) ||
              '-') + ' / 110'}
          </p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('sdmt.labels.score')))}>
          <p>
            {getLatestCommitData(d).sdmtResult &&
            (getLatestCommitData(d).sdmtResult.rightAnswerCount ||
              getLatestCommitData(d).sdmtResult.rightAnswerCount === 0)
              ? getLatestCommitData(d).sdmtResult.rightAnswerCount || '0'
              : '-'}
          </p>
        </HistoryEntryColumn>
      </HistoryEntryColumns>
    </HistoryEntry>
  );

export default historyMapper;
